export default __webpack_public_path__ + "static/media/a5_landscape.433ca944.png";